import { PluginImportConfigMappingStep } from 'pages/datasources/components/customImport/PluginImportConfigMappingStep';
import type { FC } from 'react';
import { EditorSteps } from 'ui/editor/dataStream/TileEditor/constants';
import type { StepWithCondition } from 'ui/editor/dataStream/TileEditor/hooks/useTileEditorSteps';

interface UsePluginConfigMappingStepParameters {
    isLoading: boolean;
    hasDataStream: boolean;
    isConfigured: boolean;
}

const EmptySublabel: FC = () => null;

/**
 * Create an object representing the plugin config mapping step.
 */
export const usePluginConfigMappingStep = ({
    isLoading,
    hasDataStream,
    isConfigured
}: UsePluginConfigMappingStepParameters): StepWithCondition => {
    const isEnabled = !isLoading && hasDataStream && isConfigured;

    return {
        name: EditorSteps.pluginConfigMapping,
        isEnabled,
        Sublabel: EmptySublabel,
        sublabelProps: {},
        Content: PluginImportConfigMappingStep,
        contentProps: {}
    };
};
